import { booleanAttribute, Component, input, model } from '@angular/core';
import { CdkTrapFocus } from '@angular/cdk/a11y';
import { CdkConnectedOverlay } from '@angular/cdk/overlay';
import { BspkScrim } from '../scrim';

export type DialogPlacement = 'bottom' | 'center' | 'left' | 'right' | 'top';

@Component({
  selector: 'bspk-dialog',
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss',
  imports: [CdkTrapFocus, BspkScrim, CdkConnectedOverlay, BspkScrim],
})
export class BspkDialog {
  readonly placement = input<DialogPlacement>('center');
  readonly widthFull = input(false, { transform: booleanAttribute });
  readonly open = model(false);
  readonly width = input<string | null>(null);
  protected origin = document.body;
}
